module.exports = __webpack_public_path__ + "assets/images/Saiba-mais_faz-de-conta_69c5114dba9af614ea0c2cd3c2212b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-four/Saiba-mais_faz-de-conta.png
// module id = 211
// module chunks = 0